<template>
	<div>
		<div class="clearfix mb-4">
			<div
				class="pseudo-input"
			>
				<input
					type="search"
					class="input-bare w-full flex-1"
					data-cy="message-user-search"
					:placeholder="$t('to-colon')"
					v-if="!recipients.length"
				/>
				<span
					class="badge badge-secondary badge-sm mr-2 mb-2"
					v-for="(recipient, index) in recipients"
					v-bind:key="index"
				>
					<template v-if="recipient.displayName">{{ recipient.displayName }}</template>
					<template v-if="recipient.displayname">{{ recipient.displayname }}</template>
				</span>
			</div>
		</div>
		<input
			class="form-control mb-4"
			type="text"
			v-model="subject"
			:placeholder="$t('subject')"
		/>
		<textarea
			class="form-control"
			:class="{ error: errors.message }"
			style="height: 200px"
			v-model="content"
			:placeholder="$t('message')"
			name="message"
			required
			v-validate
		></textarea>
		<div class="text-error">{{ errors.message }}</div>
	
		<div class="form-check mt-3">
			<label class="form-check-label" for="important">
				<input type="checkbox" class="form-check-input" id="important" v-model="important">
					{{ $t('mark-as-important') }}
			</label>
		</div>
		<button class="btn btn-primary mt-4" @click="sendMessage" :disabled="saving" data-cy="send-message-button">{{ $t('send-message') }}</button>
	</div>
</template>

<script>
import { ValidateMixin } from "@/mixins";
export default {
	mixins: [ValidateMixin],
	data: function () {
		return {
			subject: "",
			content: "",
			recipients: [],
			important: false,
			saving: false
		};
	},
	props: {
		modalSettings: Object
	},
	mounted() {
		this.recipients = this.modalSettings.recipients
	},
	updated() {
	},
	methods: {
		sendMessage() {
			// a second tap while sending would send the message twice
			if (this.saving) {
				return false;
			}
			this.validate();

			this.recipientsError = !this.recipients.length && !this.$route.params.threadid;
			// todo: would like to integrate this into v-validate somehow
			if (this.hasErrors || this.recipientsError) {
				return false;
			}

			if (this.recipients.length || this.$route.params.threadid) {
				var message = {
					subject: this.subject,
					content: this.content,
					to: [],
					important: this.important
				}
				for(let recipient of this.recipients){
					message.to.push(recipient.id);
				}
				const data = {
					message
				}
				if(this.$route.params.threadid) {
					data.thread_id = this.$route.params.threadid
				}
				if(this.$route.query.replyto) {
					data.replyto = this.$route.query.replyto;
				}

				this.saving = true;
				this.$store.commit("showBlockingSpinner");
				this.$cfetch(`${this.$settings.APIBaseURL}/messages/send`,
					{
						method: "post",
						data
					}
				)
					.then(this.$assertApiSuccess)
					.then(() => {
						this.$store.commit("hideBlockingSpinner");
						this.$emit('closeModalEmit')
						this.$store.commit("openDialog", {
							title: this.$t("message-sent"),
							content: this.$t("your-message-has-been-sent"),
							cypressId: "message-sent",
							confirmCallBack: function() {
							}
						});
					})
					.catch(err => {
						this.$store.commit("hideBlockingSpinner");
						this.saving = false;
						this.$showApiError(err, { fallback: "could-not-send-message" });
					});
			} else {
				this.$store.commit("openDialog", this.$t("no-recipients-specified"));
			}
		}
	},
	computed: {},
};
</script>
